export const RedirectQueryParamDtoDescriptions = {
  key: "Query parameter name appended to the destination URL.",
  value: "Query parameter value.",
} as const;

export const RedirectDtoDescriptions = {
  _schema:
    "Redirects are for URL split tests (content/url), Shopify theme tests (content/theme), and template tests (content/template).",
  id: "Server-generated. Read-only.",
  group:
    "Numeric group for organizing related redirects. Redirects sharing an originUrl should share a group number.",
  variationId: "References the parent variation.",
  originUrl:
    "URL pattern matched against visitor page URLs. Matching behavior depends on the 'filter' field.",
  destinationUrl:
    "Target URL visitors are sent to. Used when redirectType is 'fullReplacement'.",
  queryParams:
    "Key-value pairs appended to the destination URL as query parameters.",
  skip: "When true, this redirect is temporarily disabled.",
  isThemeTest:
    "True when this redirect tests alternate Shopify themes. Used with content/theme experiences.",
  isTemplateTest:
    "True when this redirect tests alternate Shopify templates. Used with content/template experiences.",
  templateType:
    "Shopify template type being tested (e.g., product, collection).",
  templateSuffixes:
    "Alternate Shopify template suffixes being tested (e.g., 'alternate', 'new-layout').",
  redirectOnce:
    "When true, the redirect fires only once per visitor session to avoid redirect loops.",
  filter:
    "Matching strategy for originUrl (e.g., exact match, contains, endsWith, regex).",
  find: "Pattern to locate within the URL for partial replacement. Only used when redirectType is 'partialReplacement'.",
  redirectType:
    "fullReplacement navigates to destinationUrl; partialReplacement swaps only the 'find' match within the current URL.",
} as const;

export const CreateRedirectDtoDescriptions = {
  _schema:
    "Creates a URL redirect. Use with content/url, content/theme, or content/template experience types.",
  group:
    "Redirects sharing the same originUrl should use the same group number.",
  originUrl:
    "URL pattern to match. Matching behavior controlled by 'filter' field.",
  destinationUrl:
    "Target URL. Required when redirectType is 'fullReplacement'.",
  queryParams: "Appended to the destination URL.",
  skip: "Set to true to temporarily disable without deleting. On a split URL test (type 'content/url') the control's entry is ALWAYS `skip: true` with `destinationUrl: null` but the SAME `originUrl`/`filter`/`find` as the treatment — the plugin matches every entry's originUrl to decide who is in the test, so control needs a matching entry that stays put. A missing or non-skipped control entry is corrected server-side. On any other experience type a redirect belongs to its own variation and keeps the `skip` you send, including on the control.",
  isThemeTest:
    "Set to true for Shopify theme testing. Use with content/theme experience type.",
  isTemplateTest:
    "Set to true for Shopify template testing. Use with content/template experience type.",
  templateType: "Required when isTemplateTest is true.",
  templateSuffixes:
    "Template suffix variations to test. Required when isTemplateTest is true.",
  redirectOnce: "Set to true to fire only once per visitor session.",
  filter: "How originUrl is matched against the current page URL.",
  find: "Pattern to find in the URL. Required when redirectType is 'partialReplacement'.",
  redirectType:
    "Full replacement navigates to destinationUrl; partial replacement swaps only the 'find' match within the current URL.",
} as const;

export const ExternalRedirectDescriptions = {
  id: "Copy from GET response. Identifies which redirect to preserve.",
  variationId: "Copy from GET response. Must match the parent variation's id.",
} as const;
